import { comics } from "@/mocks/comics";
import ComicCard from "./ComicCard";

function SectionHeading({
  kicker,
  title,
  desc,
  anchor,
}: {
  kicker: string;
  title: string;
  desc: string;
  anchor: string;
}) {
  return (
    <div id={anchor} className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-6 md:mb-8">
      <div>
        <p className="text-sm text-primary-400 font-medium mb-2">{kicker}</p>
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50">{title}</h2>
        <p className="mt-2 text-sm md:text-base text-foreground-400 max-w-xl leading-relaxed">{desc}</p>
      </div>
    </div>
  );
}

export default function HotComics() {
  const featured = comics.slice(0, 4);
  return (
    <section className="mx-auto px-4 md:px-8 py-14 md:py-20">
      <SectionHeading
        anchor="featured"
        kicker="热门推荐 · HOT PICKS"
        title="本周热门韩漫免费推荐"
        desc="编辑部精选当前最热门的韩漫免费作品，章章精彩、剧情上头的口碑之作，点击即可免费看全集。"
      />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
        {featured.map((c) => (
          <ComicCard key={c.id} comic={c} />
        ))}
      </div>
    </section>
  );
}

export { SectionHeading };